import { Component, OnInit, OnDestroy } from '@angular/core';
import { AwardCriteriaService } from '../../service/award.service';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/base.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { arwardCriteria } from 'src/app/model/awardCriteria';

@Component({
    selector: 'app-award',
    templateUrl: './award.component.html',
    styleUrls: ['./award.component.scss']
})
export class AwardComponent extends BaseComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    awards: any[] = [];
    awardData: any = {};
    searchTerm: string = '';
    awardCriteria: arwardCriteria = new arwardCriteria();

    constructor(
        private awardService: AwardCriteriaService,
        translate: TranslateService,
        loading: NgxSpinnerService,
        router: Router
    ) {
        super(router, loading, translate);
    }

    ngOnInit(): void {
        this.loadAwards();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    loadAwards(): void {
        this.loading.show();
        this.awardService.getAwardCriteria()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    this.awards = response.getAwardCriterias.map(item => ({
                        id: item.id,
                        maxPoints: item.numberOfPoints,
                        individualValue: item.individual,
                        teamValue: item.team,
                    }));
                    this.loading.hide();
                },
                error: (error) => {
                    this.loading.hide();
                    this.showMessage('Atenção', 'Erro ao carregar as premiações.');
                },
            });
    }


    newAward(): void {
        this.awardData = {};
        this.showModal('modalAward');
    }


    editAward(award: any): void {
        this.awardData = {
            maxPoints: award.maxPoints,
            individualValue: award.individualValue,
            teamValue: award.teamValue
        };

        this.awardCriteria = {
            id: award.id,
            individual: award.individualValue,
            team: award.teamValue,
            numberOfPoints: award.maxPoints
        };
        this.showModal('modalAward');
    }


    saveAward(): void {
        const maxPoints = this.awardData.maxPoints;
        const individualValue = this.awardData.individualValue;
        const teamValue = this.awardData.teamValue;

        if (maxPoints === undefined || maxPoints === '' || individualValue === undefined || individualValue === '' || teamValue === undefined || teamValue === '') {
            this.showMessage('Erro', 'Todos os campos precisam ser preenchidos.');
            return;
        }

        const maxPointsNumber = Number(maxPoints);
        const individualValueNumber = Number(individualValue);
        const teamValueNumber = Number(teamValue);

        if (isNaN(maxPointsNumber) || isNaN(individualValueNumber) || isNaN(teamValueNumber)) {
            this.showMessage('Erro', 'Por favor, insira números válidos em todos os campos.');
            return;
        }

        const input = {
            individual: individualValueNumber,
            team: teamValueNumber,
            numberOfPoints: maxPointsNumber
        };

        if (this.awardCriteria?.id) {
            this.updateAwardCriteria(input);
        } else {
            this.createAwardCriteria(input);
        }
    }

    createAwardCriteria(input: any): void {
        this.awardService.createAwardCriteria({ input })
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: () => {
                    this.awardData = {
                        maxPoints: null,
                        individualValue: null,
                        teamValue: null
                    };
                    this.loadAwards();
                    this.loading.hide();
                    this.showMessage('Sucesso', 'Premiação criada com sucesso!', 'success');
                    this.closeModal('modalAward');
                },
                error: (error) => {
                    console.error('Erro ao criar premiação:', error);
                    this.loading.hide();
                    this.showMessage('Erro', 'Erro ao criar a premiação.', 'error');
                }
            });
    }

    updateAwardCriteria(input: any): void {
        const variables = {
            id: this.awardCriteria.id,
            data: {
                individual: input.individual,
                team: input.team,
                numberOfPoints: input.numberOfPoints
            }
        };

        this.awardService.updateAwardCriteria(variables)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: () => {
                    this.loadAwards();
                    this.loading.hide();
                    this.showMessage('Sucesso', 'Premiação atualizada com sucesso!', 'success');
                    this.closeModal('modalAward');
                },
                error: (error) => {
                    console.error('Erro ao atualizar premiação:', error);
                    this.loading.hide();
                    this.showMessage('Erro', 'Erro ao atualizar a premiação.', 'error');
                }
            });
    }

    deleteAward(id: number): void {
        this.loading.show();

        this.awardService.deleteAwardCriteria(id)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (result) => {
                    if (result) {
                        this.loadAwards();
                        this.showMessage('Sucesso', 'Premiação excluída com sucesso!', 'success');
                    }
                },
                error: (error) => {
                    this.showMessage('Erro', 'Erro ao excluir a premiação.', error);
                }
            });
    }

}
